import { baseApi } from "./baseApi";
import {
  buildEncodedPaginationQueryString,
  buildLogFilterQueryString,
} from "./queryHelpers";
import {
  LogGroupDto,
  LogsDto,
  LogStatsDto,
  PaginateQuery,
} from "../../interfaces";
import { Paginated } from "../../models";

export type LogFilterQuery = Pick<PaginateQuery, "filter" | "search">;

export const logApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLogs: builder.query<Paginated<LogsDto>, PaginateQuery>({
      query: (data) => ({
        url: buildEncodedPaginationQueryString(data, `/api/log`),
      }),
      providesTags: ["Log"],
    }),
    getLogStats: builder.query<LogStatsDto, LogFilterQuery>({
      query: (data) => ({
        url: buildLogFilterQueryString(data, `/api/log/stats`),
      }),
      providesTags: ["Log"],
    }),
    getLogGroups: builder.query<Paginated<LogGroupDto>, PaginateQuery>({
      query: (data) => ({
        url: buildEncodedPaginationQueryString(data, `/api/log/groups`),
      }),
      providesTags: ["Log"],
    }),
  }),
});

export const { useGetLogsQuery, useGetLogStatsQuery, useGetLogGroupsQuery } =
  logApi;
